<template>
  <div class="container-fluid h-100">
    <div v-if="!precount" class="p-2 mx-2">Verifying request <i class="fa-solid fa-spinner fa-3x fa-spin-pulse fa-spin-reverse"></i></div>
    <div v-else>
      <p class="lead">You have requested a list of <span class="h3"><strong>{{expectedCount}} records.</strong></span></p> 
      <p class="lead">{{ formatNum(precount) }}</p>
      <p class="lead text-danger" v-if="reduceNum(expectedCount) > reduceNum(precount)">Warning: The estimated count is smaller than the requested data.</p>
      <p class="lead text-danger" v-if="reduceNum(precount) < 251">Warning: The estimated count falls within the margin of error (under 250). A list can be requested smaller than the margin of error, so it is possible there are a small amount of relevant matches, however generally this indicates zero matches.</p>
      <hr>
      <button @click="$emit('continueProcessing')" class="btn btn-lg btn-primary me-2">Continue to Generate Prospect List</button>
      <button @click="$emit('closeBack')" class="btn btn-lg btn-danger">Go Back</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['expectedCount','precount'],
  methods: {
    formatNum(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    reduceNum(str) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : null;
    }
  }
}
</script>